const set = (path) => {
    const get_item = (index, item) => {
        let li = window.$("<li />");
        li.addClass(`breadcrumb-item`);
        if (index == 0) {
            li.addClass(`ps-0`);
        }

        let a = window.$("<a/>");
        a.attr("href", `${item.link}`);
        a.text(item.name);
        li.append(a);

        return li;
    }
  
    let _container = window.$(".breadcrumb");
    _container.html("");
    for (var i = 0; i < path.length; i++) {
        _container.append(get_item(i, path[i]));
    }

}

export { set };